export default [
  {
    id: "125",
    customeremail: "abc@g.co",
    rating: "4.5/5",
    comment: "Average",
    date: "02/05/2021",
    status: " Approve",
    action:"Disapproved"
  },
  {
   id: "125",
   customeremail: "abc@g.co",
   rating: "4.5/5",
   comment: "Better",
   date: "02/05/2021",
   status: "Approved",
   action:"DisApprove"
  },
  
  
  {
    id: "125",
    customeremail: "abc@g.co",
    rating: "4.5/5",
    comment: "Average",
    date: "02/05/2021",
    status: "Disapproved",
    action:"Approve"
  }
];
